import { ChangeEvent, useEffect, useState } from "react";
import BetaBadge from "../../../../shared/BetaBadge/BetaBadge";
import IPrice_GroupUI from "../../../../../models/IPrice_GroupUI";
import INewPrice_GroupUI from "../../../../../models/INewPrice_GroupUI";
import { OwFnInput } from "../../../../shared/OwFnInput/OwFnInput";
import {OwDeleteEditActions} from "../../../../shared/OwDeleteEditActions/OwDeleteEditActions";
import {OwAcceptCancelActions} from "../../../../shared/OwAcceptCancelActions/OwAcceptCancelActions";

type Props = {
    index: number;
    priceGroup?: IPrice_GroupUI | INewPrice_GroupUI;
    deletePriceGroup: (priceGroup: IPrice_GroupUI | INewPrice_GroupUI, index: number) => void;
    updatePriceGroup: (priceGroup: IPrice_GroupUI | INewPrice_GroupUI, index: number) => void;
    isEditing: (isEditing: boolean) => void;
};

export const PriceGroupRow = (props: Props) => {
    const [editMode, setEditMode] = useState(props.priceGroup?.editMode || false);
    const [priceGroup, setPriceGroup] = useState(props.priceGroup || ({} as IPrice_GroupUI | INewPrice_GroupUI));
    const [isUpdated, setIsUpdated] = useState(false);

    useEffect(() => {
        if (editMode) {
            props.isEditing(true);
        }
    }, []);

    useEffect(() => {
        if (!editMode) {
            if (isUpdated) {
                props.updatePriceGroup(priceGroup, props.index);
            }
        }

        props.isEditing(editMode);
    }, [editMode]);

    const togglePriceGroupNameEdit = () => {
        const _priceGroup = {
            ...priceGroup,
            editMode: !editMode,
        };
        setPriceGroup(_priceGroup);
        setEditMode(!editMode);
    };

    const editPriceGroupName = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const _priceGroup = {
            ...priceGroup,
        };

        // @ts-expect-error
        _priceGroup[name] = value;
        _priceGroup.isUpdated = true;

        setPriceGroup(_priceGroup);
        setIsUpdated(true);
    };

    const deletePriceGroup = () => {
        props.deletePriceGroup(priceGroup, props.index);
    };

    return (
        <div
            id={`price-group-row-${props.index}`}
            className={"d-flex flex-row align-items-center mb-2 position-relative"}
            key={props.index}
            style={{ height: "38px" }}>


            <OwDeleteEditActions
                isEditMode={editMode}
                onTrashClickFn={deletePriceGroup}
                onEditClickFn={togglePriceGroupNameEdit}
                className={""}
            />

            <OwAcceptCancelActions
                isEditMode={!editMode}
                onAcceptClickFn={togglePriceGroupNameEdit}
                onCancelClickFn={togglePriceGroupNameEdit}
                disableAccept={priceGroup.value.length < 1}
            />

            <div className={"ms-2"}>
                {editMode ? (
                    <OwFnInput name={"value"} value={priceGroup.value} fn={editPriceGroupName} placeholder={"name"} minLength={1} />
                ) : (
                    priceGroup.value
                )}
            </div>


            {!editMode && priceGroup.isNew ? <BetaBadge title={"new"} className={"ms-2"} /> : null}
        </div>
    );
};
